/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FormSubmission,
} from '../models/index';
import {
    FormSubmissionFromJSON,
    FormSubmissionToJSON,
} from '../models/index';

export interface FormsSubmitCreateRequest {
    teamSlug: string;
    formSubmission: Omit<FormSubmission, 'id'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class FormsApi extends runtime.BaseAPI {

    /**
     */
    async formsSubmitCreateRaw(requestParameters: FormsSubmitCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormSubmission>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling formsSubmitCreate().'
            );
        }

        if (requestParameters['formSubmission'] == null) {
            throw new runtime.RequiredError(
                'formSubmission',
                'Required parameter "formSubmission" was null or undefined when calling formsSubmitCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/forms/{team_slug}/submit/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormSubmissionToJSON(requestParameters['formSubmission']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormSubmissionFromJSON(jsonValue));
    }

    /**
     */
    async formsSubmitCreate(requestParameters: FormsSubmitCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormSubmission> {
        const response = await this.formsSubmitCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
